var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDropFile = function SvgDropFile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 37,
    viewBox: "0 0 67 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6598 17.037L57.8991 34.7667C57.6106 35.6545 56.6571 36.1403 55.7694 35.8518L39.6952 30.629C38.8074 30.3406 38.3216 29.3871 38.6101 28.4993L46.2702 4.92383C46.5586 4.03607 47.5121 3.55024 48.3999 3.83869L58.7752 7.20982",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6598 17.037V17.037L57.8991 34.7667C57.6106 35.6545 56.6571 36.1403 55.7694 35.8518L39.6952 30.629C38.8074 30.3406 38.3216 29.3871 38.6101 28.4993L46.2702 4.92383C46.5586 4.03607 47.5121 3.55024 48.3999 3.83869L58.7752 7.20982V7.20982",
    stroke: "#2684FF",
    strokeWidth: 1.12676
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.972517
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4099 18.5107L49.4743 19.8314L48.8808 21.658L44.8164 20.3374L45.4099 18.5107Z",
    fill: "#C3E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0034 16.6836L58.8219 20.8486L58.3471 22.3099L45.5286 18.1449L46.0034 16.6836Z",
    fill: "#C3E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7869 19.9326L53.8513 21.2532L53.2578 23.0798L49.1934 21.7592L49.7869 19.9326Z",
    fill: "#C3E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1638 21.3545L58.2282 22.6751L57.6347 24.5017L53.5703 23.1811L54.1638 21.3545Z",
    fill: "#C3E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6975 20.7031L48.7619 22.0237L48.1684 23.8504L44.104 22.5297L44.6975 20.7031Z",
    fill: "#C3E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0747 22.125L53.1391 23.4456L52.5456 25.2722L48.4812 23.9516L49.0747 22.125Z",
    fill: "#C3E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4517 23.5469L57.5161 24.8675L56.9226 26.6941L52.8582 25.3735L53.4517 23.5469Z",
    fill: "#C3E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9853 22.8945L48.0498 24.2151L47.4563 26.0418L43.3918 24.7211L43.9853 22.8945Z",
    fill: "#C3E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3625 24.3174L52.427 25.638L51.8335 27.4646L47.769 26.144L48.3625 24.3174Z",
    fill: "#C3E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7395 25.7393L56.8039 27.0599L56.2104 28.8865L52.146 27.5659L52.7395 25.7393Z",
    fill: "#C3E2FB"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.003 8.05915L63.15 16.3479L58.4144 14.996C57.4726 14.7272 56.9558 13.7167 57.289 12.7957L59.003 8.05915Z",
    fill: "white",
    stroke: "#2684FF",
    strokeWidth: 1.12676
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.052 10.7698L27.8128 28.4995C28.1012 29.3873 27.6154 30.3408 26.7276 30.6292L10.6534 35.852C9.76568 36.1405 8.81218 35.6546 8.52373 34.7669L0.863591 11.1914C0.575142 10.3037 1.06097 9.35015 1.94873 9.0617L12.324 5.69057",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.052 10.7698V10.7698L27.8128 28.4995C28.1012 29.3873 27.6154 30.3408 26.7276 30.6292L10.6534 35.852C9.76568 36.1405 8.81218 35.6546 8.52373 34.7669L0.863591 11.1914C0.575142 10.3037 1.06097 9.35015 1.94873 9.0617L12.324 5.69057V5.69057",
    stroke: "#2684FF",
    strokeWidth: 1.12676
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1718 28.8997L13.9225 27.6811L12.5297 23.3946L8.77905 24.6133L10.1718 28.8997Z",
    fill: "#C3E2FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7446 26.1151L22.4953 24.8965L20.4062 18.4668L16.6555 19.6855L18.7446 26.1151Z",
    fill: "#C3E2FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4581 27.5075L18.2088 26.2888L15.4233 17.7159L11.6726 18.9346L14.4581 27.5075Z",
    fill: "#C3E2FB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9959 6.24959L21.2084 10.5075L16.6079 12.1985C15.6886 12.5364 14.6755 12.0246 14.4019 11.0841L12.9959 6.24959Z",
    fill: "white",
    stroke: "#2684FF",
    strokeWidth: 1.12676
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.634 9.08971V27.7318C43.634 28.6652 42.8773 29.4219 41.9438 29.4219H25.0424C24.109 29.4219 23.3523 28.6652 23.3523 27.7318V2.94307C23.3523 2.00963 24.109 1.25293 25.0424 1.25293H35.9517",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.634 9.08971V27.7318C43.634 28.6652 42.8773 29.4219 41.9438 29.4219H25.0424C24.109 29.4219 23.3523 28.6652 23.3523 27.7318V2.94307C23.3523 2.00963 24.109 1.25293 25.0424 1.25293H35.9517",
    stroke: "#2684FF",
    strokeWidth: 1.12676
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4218 16.0435C35.4328 16.0309 35.4465 16.02 35.4622 16.0114C35.5333 15.9728 35.6294 15.9885 35.6767 16.0465L40.7911 22.3173C40.808 22.338 40.817 22.3624 40.817 22.3873C40.817 22.457 40.7478 22.5136 40.6623 22.5136H27.4506C27.4208 22.5136 27.3915 22.5065 27.3665 22.4933C27.2948 22.4554 27.2743 22.3772 27.3208 22.3186L29.5218 19.5446C29.5288 19.5358 29.5372 19.5277 29.5467 19.5206C29.6094 19.4732 29.7073 19.4764 29.7653 19.5276L31.1233 20.7275C31.1306 20.734 31.1387 20.7398 31.1475 20.7448C31.2171 20.7852 31.3137 20.7718 31.3631 20.7149L35.4218 16.0435Z",
    fill: "#BBDEFB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.7606,
    cy: 15.6194,
    rx: 1.33803,
    ry: 1.40845,
    fill: "#BBDEFB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4634 2.00879L43.2203 8.94474H38.1535C37.2201 8.94474 36.4634 8.18804 36.4634 7.2546V2.00879Z",
    fill: "white",
    stroke: "#2684FF",
    strokeWidth: 1.12676
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDropFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "drop-file.d83fb109f1dd49b139db2418567f18ad.svg";